import type { MenuBackgrounds } from '../types/menu';

interface GetMenuDynamicStylesArgs {
  isSelected?: boolean;
  backgrounds?: MenuBackgrounds;
  isNested?: boolean;
  isEnterActive?: boolean;
  isKeyboardNavigation?: boolean;
  isHighlighted?: boolean;
  disabled?: boolean;
}

export const getMenuDynamicStyles = ({
  isSelected,
  backgrounds,
  isNested,
  isEnterActive,
  isKeyboardNavigation,
  isHighlighted,
  disabled,
}: GetMenuDynamicStylesArgs) => {
  const canShowPressed = isEnterActive && !disabled && !isNested;

  const hoverBg = isSelected ? backgrounds?.selectedHover : backgrounds?.hover;

  const activeBg = isSelected
    ? backgrounds?.selectedActive
    : backgrounds?.active;

  const hoverStyles =
    !isKeyboardNavigation && !disabled
      ? { '&:hover': { background: hoverBg } }
      : {};

  const pseudoStyles =
    isNested || disabled
      ? {}
      : {
          '&:focus-visible': { background: hoverBg },
          '&:active': { background: activeBg },
        };

  switch (true) {
    case canShowPressed && isSelected:
      return {
        background: backgrounds?.selectedActive,
        ...hoverStyles,
        ...pseudoStyles,
      };
    case canShowPressed:
      return {
        background: backgrounds?.active,
        ...hoverStyles,
        ...pseudoStyles,
      };
    case isHighlighted && isSelected:
      return {
        background: backgrounds?.selectedHover,
        ...hoverStyles,
        ...pseudoStyles,
      };
    case isHighlighted:
      return {
        background: backgrounds?.hover,
        ...hoverStyles,
        ...pseudoStyles,
      };
    case isSelected:
      return {
        background: backgrounds?.selected,
        ...hoverStyles,
        ...pseudoStyles,
      };
    default:
      return { background: backgrounds?.idle, ...hoverStyles, ...pseudoStyles };
  }
};
